import { GoalDTO } from '../../dto/goal/goal.dto';

export class Goal {
    goal_id: number | undefined;
    base_goal_id: number | undefined;
    name: string;
    descriptions: { [key: string]: { language_code: string, translation_text: string } };
    version_start_date: Date;
    version_end_date: Date | undefined;
    visibility: string;
    subtypes: Array<{ subtype_id: number }> = [];
    versions: Goal[] = [];

    constructor(
        name: string,
        descriptions: { [key: string]: { language_code: string, translation_text: string } },
        version_start_date: Date,
        version_end_date?: Date,
        visibility: string = 'public',
        subtypes: Array<{ subtype_id: number }> = [],
        goal_id?: number,
        base_goal_id?: number
    ) {
        this.name = name;
        this.descriptions = descriptions;
        this.version_start_date = version_start_date;
        this.version_end_date = version_end_date;
        this.visibility = visibility;
        this.subtypes = subtypes;
        this.goal_id = goal_id;
        this.base_goal_id = base_goal_id;
    }

    public static convertToDTO(model: Goal): GoalDTO {
        return {
            name: model.name,
            descriptions: model.descriptions,
            version_start_date: model.version_start_date,
            version_end_date: model.version_end_date,
            visibility: model.visibility,
            subtypes: model.subtypes,
            goal_id: model.goal_id,
            base_goal_id: model.base_goal_id
        };
    }

    public static fromDTO(dto: GoalDTO): Goal {
        return new Goal(
          dto.name,
          dto.descriptions,
          dto.version_start_date,
          dto.version_end_date,
          dto.visibility,
          dto.subtypes,
          dto.goal_id,
          dto.base_goal_id
        );
    }
} 